/** Backward-compatible re-exports. Prefer @/lib/site-metadata for new code. */
export {
    SITE_URL,
    SITE_NAME,
    SEO_TAGLINE,
    DEFAULT_DESCRIPTION,
    TWITTER_HANDLE,
    SUPPORT_EMAIL,
    SHARED_KEYWORDS,
    buildSeoTitle,
    buildAbsoluteUrl,
    buildOgImageUrl,
    buildLanguageAlternates,
    createPageMetadata,
} from "@/lib/site-metadata";

export { buildStaticShareImagePath } from "@/lib/share-image-config";

export const DEFAULT_OG_IMAGE = "/images/share/en.png";
